import { lazy } from "react";

export { TRIGGER_ACTION_ID_PARAM, TRIGGER_ACTION_LIST_PATH } from "./path";
export const TriggerActionListPage = lazy(() => import("./page"));
